import UserAccount from './user-account/UserAccount.mjs';

document.addEventListener('DOMContentLoaded', (event) => {
  if (UserAccount.isMCCSite() && UserAccount.isLoggedIn()) {
    const token = UserAccount.getAuthToken();

    if (token) {
      document.querySelectorAll('a[href*="magiccityrewards.com"]').forEach(link => {
        link.href = link.href + '?token=' + token;
      });
    }
  }
});
